import React from 'react'
import { useHistory } from 'react-router-dom'
import { Toast } from 'lib/ui'
import { useComparisonContext } from 'lib/modules/catalog'
import { ReactComponent as CompareSvg } from 'resources/svg/icons/compare.svg'
import { CompareLink } from './styled'

interface Props {
  sku: string
  useIcon?: boolean
}

export const AddToCompare = ({ sku, useIcon = false }: Props) => {
  const history = useHistory()
  const { addProductToCompare } = useComparisonContext()
  const addCurrentProductToCompare = (e: any) => {
    e.preventDefault()
    const added = sku && addProductToCompare(sku)
    if (!added) {
      Toast.toastFailure({ messageId: 'comparison.max' })
    } else {
      history.push('/product-comparison')
    }
  }
  return (
    <CompareLink href='/product-comparison' onClick={addCurrentProductToCompare} hasIcon={useIcon}>
      <CompareSvg />
      <span>Compare</span>
    </CompareLink>
  )
}
